import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import BidPricesForm from './bidPricesForm';
import BidPricesEdit from './bidPricesEdit';

export default angular.module('app.components.admin.bidPrices', [
  'ui.router',
  BidPricesForm.name,
  BidPricesEdit.name
])
  .config(function($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app.admin.bidPrices', {
        abstract: true,
        url: '/bidPrices',
        template: '<ui-view/>'
      })
      .state('app.admin.bidPrices.edit', {
        url: '',
        template: '<bid-prices-edit></bid-prices-edit>',
        resolve: {
          $title: ($filter) => {
            $filter('translate')('$state.app.admin.bidPrices.edit');
          }
        }
      });
  })



/** WEBPACK FOOTER **
 ** ./src/components/admin/bidPrices/bidPrices.js
 **/